import type { CommaDelimitedLocationType } from '../types';
import { useLocationControl } from './use_location_control';
import { useCallback } from 'react';

export const useResultSelected = (locationType: CommaDelimitedLocationType) => {
  const locationControl = useLocationControl(locationType);

  return useCallback(
    (result) => {
      return locationControl.resultSelected(result);
    },
    [locationControl]
  );
};
